module.exports = __webpack_public_path__ + "static/img/yamamoto_01.347668c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/yamamoto_01.jpg
// module id = BYqi
// module chunks = 0